<template>
  <div v-if="editTime">
    <div class="example-basic">
      <el-time-picker
          v-model="time"
          :arrow-control="false"
          :placeholder=placeh
          format="HH:mm"
          @change="test"
          :clearable="false"
      />
    </div>
  </div>
  <div class="flex items-center gap-1.5" v-else>
    <div class="responsive-title-6 font-semibold">
      {{ formattedTime }}
    </div>
    <img @click="editTime=true" src="@/assets/icons/svg/Edit_16x16.svg" alt="edit-time"
         class="h-4 cursor-pointer">
  </div>

</template>

<script lang="ts" setup>
import {ref} from 'vue'
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const placeh = ref(t('tripTime'))
const props = defineProps({
    hour:String,
    minutes:String,
})

const editTime = ref(false);
const time = ref(new Date());
time.value.setHours( props.hour,props.minutes,0,0 );

const formatter = new Intl.DateTimeFormat('en-US', { hour: '2-digit', minute: '2-digit' });
const formattedTime = ref(formatter.format(time.value));

function test() {
  editTime.value = false;
  formattedTime.value = formatter.format(time.value);
}
</script>

<style>
.example-basic .el-date-editor {
  margin: 8px;
}
</style>
